import { connectApiState } from './api/connectApiState';
import { cloudsaveQueryApi } from './api/cloudsave/cloudsaveQueryApi';
import { suggestionsQueryApi } from './api/suggestions/suggestionsQueryApi';
import { rootReducer } from './store/index';

import createSagaMiddleware from 'redux-saga';
import { unitSagas } from 'store/units/sagas';
import simulationSagas from 'store/simulation/sagas';
import performanceguaranteeSagas from 'store/performanceGuarantee/sagas';
import connectionSagas from 'store/connections/sagas';
import { cloudsaveSagas } from 'store/storageunits/sagas';
import unitInfoDataSagas from 'store/unitInfoData/sagas';
import documentMetadataSagas from 'store/documentMetadata/sagas';
import fileStateSagas from 'store/fileState/sagas';
import { configureStore } from '@reduxjs/toolkit';
import { isProd } from 'util/env';
import chamberAnalysisSagas from 'store/chamberAnalysis/sagas';

const sagaMiddleware = createSagaMiddleware();

/*Logger to show actions, and state.
* Can be used to see the flow of sagas,
* and if actions are run in a loop
const logger: Middleware<{}, any> = (store) => (next) => (action) => {
  //const start =performance.now();
  console.group(action.type);
  console.info('dispatching', action);
  let result = next(action);
  console.log('next state', store.getState());
  //const end = performance.now();
  //console.log(`${end-start} ms`);
  console.groupEnd();
  return result;
};
* */

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      actionCreatorCheck: false,
    }).concat(
      sagaMiddleware,
      suggestionsQueryApi.middleware,
      cloudsaveQueryApi.middleware,
    ),
  devTools: !isProd(),
});

sagaMiddleware.run(unitSagas);
sagaMiddleware.run(simulationSagas);
sagaMiddleware.run(chamberAnalysisSagas);
sagaMiddleware.run(performanceguaranteeSagas);
sagaMiddleware.run(connectionSagas);
sagaMiddleware.run(cloudsaveSagas);
sagaMiddleware.run(documentMetadataSagas);
sagaMiddleware.run(fileStateSagas);
sagaMiddleware.run(unitInfoDataSagas);

const disconnectApiState = connectApiState(store);
if (import.meta.hot) import.meta.hot.dispose(disconnectApiState);
